/**
 * Operation Center - English (US)
 * 运营中心 - 美式英语
 */
export default {
  title: 'Operation Center',
  equipmentManagement: 'Equipment Management',
  barterManage: 'Barter Manage',
  freightFees: 'Freight Fees',
  payment: 'Payment',
  purchaseOrderNo: 'Purchase Order No.',
  orderTime: 'Order Time',
  purchaseQty: 'Purchase Qty',
  purchaseAmount: 'Purchase Amount',
  paidAmount: 'Paid Amount',
  freightPlan: 'Freight Plan',
  planOne: 'Plan 1: Freight Collect',
  planTwo: 'Plan 2: Freight Prepaid',
  payFreightCollect: 'Pay (Freight Collect)',
  payFreightPrepaid: 'Pay (Freight Prepaid)',
  cloudWarehouseManagement: 'Cloud Warehouse',
  purchasingManagement: 'Purchasing Management',
  partner: 'Partner',
  channelAgents: 'Channel Agents',
  // 运费弹窗
  unit: 'units',
  yuan: 'yuan',
  planOneDesc: 'Pay to courier on delivery; actual amount may vary by about 20%.',
  planTwoDesc: 'Original price {original} yuan, paid with order; disputes handled by headquarters.',
  chargeItem: 'Charge Item',
  unitPrice: 'Unit Price',
  quantity: 'Qty',
  amount: 'Amount',
  discount: 'Discount',
  amountAfterDiscount: 'Amount After Discount',
  orderFreightTipIntro: 'This order has fewer than 10 units; per company policy freight is collect. We offer prepaid collect freight so you can enjoy discounted shipping. Please note:',
  freightRule1: '1. Collect freight discount is per our agreement with JD warehouse (currently 35% off); we will notify you of any change.',
  freightRule2: '2. Prepaid collect freight is optional. If you do not prepay, you must pay the courier on delivery; amount and method are as per the courier.',
  freightRule3: '3. If this order is merged with others and qualifies for free shipping (10+ units), prepaid freight will be refunded automatically.',
  premium: 'Premium',
  doNotOperateTooFrequently: 'Please do not operate too frequently.',
  paymentFailed: 'Payment failed.',
  // Barter list & dialogs
  addBarter: 'Add Barter',
  operation: 'Operation',
  deliver: 'Deliver',
  more: 'More',
  confirmReceipt: 'Confirm Receipt',
  modify: 'Modify',
  audit: 'Audit',
  cancelConfirm: 'Cancel Confirm',
  barterOrderNo: 'Barter Order No.',
  shipInProductName: 'Ship-in Product',
  shipInQty: 'Ship-in Qty',
  shipOutProductName: 'Ship-out Product',
  shipOutQty: 'Ship-out Qty',
  barterPriceDiff: 'Price Diff',
  cancelConfirmTip: 'Are you sure to cancel? This barter application will be void and cannot be restored. You can create a new one if needed.',
  payDeductTip: 'This payment will deduct:',
  cashAccount: 'Cash Account',
  goldAccount: 'Gold Account',
  deliveryVoucherAccount: 'Delivery Voucher Account',
  gotIt: 'Got it',
  paySuccessTitle: 'Payment Succeeded',
  payFailTitle: 'Payment Failed',
  paySuccessAmount: 'Successfully paid ¥{money}',
  payFailAmount: 'Failed to pay ¥{money}',
  cancelSuccess: 'Cancelled successfully',
  tip: 'Tip',
  // Barter table & search
  barterStatus: 'Barter Status',
  priceDiffAmount: 'Price Diff Amount',
  prepaidFreight: 'Prepaid Freight',
  receivedAmount: 'Paid Amount',
  payStatus: 'Payment Status',
  remark: 'Remark',
  applyAgentId: 'Applicant Agent ID',
  applyAgentName: 'Applicant Agent Name',
  shipOutProductNameCol: 'Ship-out Product',
  shipOutProductQty: 'Ship-out Qty',
  productLevel: 'Price Level',
  shipOutShipStatus: 'Ship-out Status',
  swapAgentId: 'Swap Agent ID',
  swapAgentName: 'Swap Agent Name',
  shipInProductNameCol: 'Ship-in Product',
  shipInProductQty: 'Ship-in Qty',
  shipInShipStatus: 'Ship-in Status',
  submitTime: 'Submit Time',
  auditUser: 'Auditor',
  auditTime: 'Audit Time',
  createUser: 'Created By',
  createTime: 'Create Time',
  placeholderBarterOrderNo: 'Enter barter order no.',
  applyAgent: 'Applicant Agent',
  placeholderApplyAgent: 'Select agent',
  swapAgent: 'Swap Agent',
  placeholderSwapAgent: 'Select swap agent',
  self: 'Self',
  placeholderBarterStatus: 'Select barter status',
  shipOutStatus: 'Ship-out status',
  shipInStatus: 'Ship-in status',
  barterProductName: 'Product Name',
  placeholderBarterProductName: 'Enter product name',
  productName: 'Product Name',
  placeholderProductName: 'Enter product name',
  applyReceiveWarehouse: 'Applicant Warehouse',
  placeholderApplyWarehouse: 'Select applicant warehouse',
  swapReceiveWarehouse: 'Swap Warehouse',
  placeholderSwapWarehouse: 'Select swap warehouse',
  cloudOrderNo: 'Cloud Order No.',
  placeholderCloudOrderNo: 'Enter cloud order no.',
  expressNo: 'Express No.',
  placeholderExpressNo: 'Enter express no.',
  placeholderCreateTime: 'Create time',
  placeholderSubmitTime: 'Submit time',
  placeholderAuditTime: 'Audit time',
  placeholderPayStatus: 'Select payment status',
  to: 'to',
  // Deliver goods dialog
  applyShipWarehouse: 'Applicant Ship Warehouse',
  swapShipWarehouse: 'Swap Ship Warehouse',
  applyReceiveWarehouseLabel: 'Applicant Receive Warehouse',
  swapReceiveWarehouseLabel: 'Swap Receive Warehouse',
  applyReceiver: 'Applicant Receiver',
  swapReceiver: 'Swap Receiver',
  receiverPhone: 'Receiver Phone',
  provinceCityDistrict: 'Province/City/District',
  detailAddress: 'Detail Address',
  shipOutExpressNo: 'Ship-out Express No.',
  shipInExpressNo: 'Ship-in Express No.',
  placeholderSelectWarehouse: 'Select warehouse',
  placeholderProductExpressNo: 'Enter product express no.',
  transferUnselected: 'Unselected',
  transferSelected: 'Selected',
  placeholderSnCode: 'Enter SN code',
  snCode: 'SN Code',
  productNameLabel: 'Product Name',
  // Take confirm dialog
  shipInLabel: 'Ship-in',
  shipOutLabel: 'Ship-out',
  receiveConfirmTitle: 'Product Receive Confirm',
  productExpressNo: 'Product Express No.',
  productShipStatus: 'Product Ship Status',
  cloudShipOrderNo: 'Cloud Ship Order No.',
  confirmReceiveCheck: 'Receive confirmed: model, qty and SN match',
  refuseAccept: 'Refuse',
  placeholderRefuseReason: 'Enter reason for refusal',
  receiveConfirmTip: 'Once confirmed, barter product SN will be transferred to swap party and cannot be returned.',
  pleaseCheckItem: 'Please check the verification item.',
  pleaseFillRefuseReason: 'Please fill in the reason for refusal.',
  // Payment / bank transfer
  priceDiffAmountLabel: 'Price Diff Amount',
  freightLabel: 'Freight',
  relatedAgent: 'Related Agent',
  accountBalance: 'Account Balance',
  relatedAgentBalance: 'Related Agent Balance',
  availableAmount: 'Available',
  remainingPayAmount: 'Remaining Pay Amount',
  payMethod: 'Payment Method',
  bankTransfer: 'Bank Transfer',
  transferAmount: 'Transfer Amount',
  payTime: 'Payment Time',
  payTimeRequired: 'Payment time is required',
  selectPayTime: 'Select payment time',
  paySerialNo: 'Payment Serial No.',
  placeholderPaySerialNo: 'Enter payment serial no.',
  payVoucher: 'Payment Voucher',
  payVoucherRequired: 'Payment voucher is required',
  voucherTip: 'Support jpg/png, recommended 1080x1920, max 5MB',
  voucherExample: 'Voucher Example',
  bankAccount: 'Bank Account',
  openingBank: 'Opening Bank',
  payRemark: 'Payment Remark',
  placeholderPayRemark: 'Enter payment remark',
  // 微信/支付宝付款
  payAmountYuan: 'Pay {amount}',
  qrcodeGenerating: 'Generating QR code...',
  scanWithAlipay: 'Scan with Alipay',
  scanWithWechat: 'Scan with WeChat',
  // 二维码地址不正确
  qrcodeUrlInvalid: 'Invalid QR code URL',
  placeholderRemark200: 'Enter remark within 200 characters',
  auditRemark: 'Audit Remark',
  applyInfo: 'Application Info',
  // Barter detail information.vue
  receiveWarehouse: 'Receive Warehouse',
  receiver: 'Receiver',
  placeholderDetailAddress: 'Enter detail address',
  shipStatus: 'Ship Status',
  addSelectShipOutProduct: '+ Select ship-out products',
  addSelectShipInProduct: '+ Select ship-in products',
  shipOutTotalAmount: 'Ship-out total: ',
  shipInTotalAmount: 'Ship-in total: ',
  swapInfo: 'Swap Info',
  swapAgentLabel: 'Swap Agent',
  productLevelName: 'Price Level',
  selectShipOutProduct: 'Select Ship-out Products',
  selectShipInProduct: 'Select Ship-in Products',
  shipOutProductModel: 'Ship-out product model',
  shipInProductModel: 'Ship-in product model',
  placeholderSelectProductModel: 'Select product model',
  diffPriceNoMerge: '**Products with different unit prices cannot be merged for barter**',
  productSwapableQty: 'Swapable qty: ',
  swapQty: 'Swap qty',
  placeholderEnterQty: 'Enter quantity',
  priceDiffAmountLabelBottom: 'Price diff amount: ',
  auditOpinion: 'Audit Opinion',
  auditResultLabel: 'Audit result: ',
  agree: 'Approve',
  refuse: 'Reject',
  placeholderAuditOpinion100: 'Enter audit opinion within 100 characters',
  applySide: 'Applicant',
  swapSide: 'Swap',
  enterReceiver: 'Enter {type} receiver',
  enterReceiverPhone: 'Enter {type} receiver phone',
  selectProvinceCityDistrict: 'Select {type} province/city/district',
  enterDetailAddress: 'Enter {type} detail address',
  enterReceiverShort: 'Enter receiver',
  enterReceiverPhoneShort: 'Enter receiver phone',
  selectProvinceCityDistrictShort: 'Select province/city/district',
  enterDetailAddressShort: 'Enter detail address',
  pleaseSelectShipOut: 'Please select ship-out products',
  pleaseSelectShipIn: 'Please select ship-in products',
  chooseProductTitle: 'Product',
  warehouseMustMatch: 'Receive warehouses for ship-in and ship-out must be the same; for cloud warehouse, use same location.',
  priceDiffMustBeValid: 'Price diff must be less than ship-out unit price and ≥ 0. Please adjust quantities and save again.',
  hqBarterDiffZero: 'For HQ barter "HQ buyback product", price diff must be 0.',
  selectAuditResult: 'Please select audit result',
  enterAuditOpinion: 'Please enter audit opinion',
  swapQtyMin1: 'Swap quantity cannot be less than 1',
  swapQtyMaxExceed: 'Swap quantity cannot exceed available quantity for this product in this warehouse',
  pleaseSelectToSelected: 'Please move items to selected area',
  diffModelOrPriceNoMerge: 'Products of different model or price cannot be merged for barter',
  confirmChangeWarehouseApply: 'Changing warehouse will clear all selected ship-out products. Continue?',
  confirmChangeWarehouseSwap: 'Changing warehouse will clear all selected ship-in products. Continue?',
  confirmChangeCampus: 'Changing swap agent will clear all selected ship-in products. Continue?',
  eclpOrderNo: 'Cloud Order No.',
  unitPriceLabel: 'Unit price: ',
  // Deliver goods dialog
  shipOutDeliverTitle: 'Ship-out Product Delivery',
  shipInDeliverTitle: 'Ship-in Product Delivery',
  pleaseEnterFullExpressNo: 'Please enter the full express number',
  deliverSuccess: 'Delivery succeeded',
  qtyNotMatchShipIn: 'Quantity does not match ship-in products',
  // Payment
  selectPayMethodForRemaining: 'Please select a payment method for the remaining amount',
  insufficientBalanceRecharge: 'Insufficient balance. Please recharge first.',
  // Bank transfer
  paySuccess: 'Payment succeeded',
  imageFormatJpgPng: 'Images must be JPG/PNG format!',
  imageSizeMax5M: 'Image size must be under 5MB. Please compress and upload.',
  confirmRemoveFile: 'Remove {name}?',
  // WeChat / Alipay
  alipay: 'Alipay',
  wechatPay: 'WeChat Pay',
  // Subscription card
  subscriptionCardManage: 'Subscription Card Management',
  copyCardNo: 'Copy Card No.',
  copyCardPassword: 'Copy Card Password',
  extendValidity: 'Extend Validity',
  markValid: 'Mark Valid',
  void: 'Void',
  confirmExtend30Days: 'Extend subscription card validity by 30 days?',
  confirmMarkVoid: 'Mark this subscription card as void?',
  confirmMarkValid: 'Mark this subscription card as valid?',
  agentId: 'Agent ID',
  agentName: 'Agent Name',
  placeholderAgent: 'Select agent',
  subscriptionCardType: 'Card Type',
  subscriptionCardNo: 'Card No.',
  subscriptionCardStatus: 'Card Status',
  returnApplyStatus: 'Return Apply Status',
  purchaseTime: 'Purchase Time',
  validDate: 'Valid Date',
  copySuccess: 'Copied',
  copyFailed: 'Copy failed!',
  extendSuccess: 'Extended successfully',
  extendFailed: 'Extension failed',
  voidSuccess: 'Voided successfully',
  voidFailed: 'Void failed',
  markValidSuccess: 'Marked valid successfully',
  markValidFailed: 'Mark valid failed',
  cancelSuccessShort: 'Cancelled successfully',
  cancelFailed: 'Cancel failed',
  // Subscription card config
  placeholderCardNo: 'Enter card no.',
  placeholderCardStatus: 'Select card status',
  buyTimeLabel: 'Purchase Date',
  validTimeLabel: 'Valid Date',
  returnApplyStatusLabel: 'Return Apply Status',
  placeholderReturnApplyStatus: 'Select return apply status',
  notApply: 'Not applicable',
  pendingApply: 'Pending',
  applied: 'Applied',
  rangeTilde: ' ~ ',
  // 云仓 CloudWarehouse
  totalStock: 'Total stock',
  availableStock: 'Available stock',
  warehouseLabel: 'Warehouse',
  placeholderWarehouse: 'Select warehouse',
  productNameCol: 'Product name',
  warehouseNameCol: 'Warehouse name',
  // 首单奖励 FirstReward
  orderNoLabel: 'Order no.',
  placeholderOrderNo: 'Enter order no.',
  dispatchTimeLabel: 'Dispatch time',
  placeholderDispatchTime: 'Select dispatch time range',
  settleYearMonthLabel: 'Settle month',
  placeholderSettleYearMonth: 'Select settle month',
  introduceCustomId: 'Introduce customer ID',
  introduceCustomName: 'Introduce customer name',
  contractAmount: 'Contract amount',
  orderStatusName: 'Order status',
  productName: 'Product name',
  buyNum: 'Purchase qty',
  receiveNum: 'Dispatch qty',
  productPrice: 'Unit price',
  orderAmount: 'Order amount',
  orderContractAmount: 'Contract paid',
  totalContractAmount: 'Total contract amount',
  lastDispatchTime: 'Dispatch time',
  rewardRateStr: 'Reward rate',
  rewardAmount: 'Reward amount',
  totalRewardAmount: 'Total reward',
  monthCol: 'Settle month',
  introduceCampusId: 'Partner ID',
  introduceCampusName: 'Partner name',
  payStatusName: 'Pay status',
  exportBtn: 'Export',
  // 转介绍客户 IntroduceCustomer
  introduceCustomerLabel: 'Introduce customer',
  placeholderIntroduceCustomer: 'Select introduce customer',
  agentTypeLabel: 'Agent type',
  placeholderAgentType: 'Select agent type',
  areaLabelPartner: 'Province/City/District',
  placeholderArea: 'Select area',
  accountActivationTimeLabel: 'Account first activation time',
  placeholderAccountActivationTime: 'Select activation time range',
  agentLevelName: 'Agent level',
  contractMoney: 'Contract amount',
  firstContractAmount: 'First contract recharge',
  firstContractTotalAmount: 'First contract total paid',
  activateTimeCol: 'First activation time',
  orderNoLabelShort: 'Order no.',
  placeholderOrderNoShort: 'Enter order no.',
  renewPayAmount: 'Renew pay amount',

  // 渠道代理首单奖励 AgentFirstPaymentReward
  placeholderMonth: 'Select month',
  isFirstRewardLabel: 'First or not',
  placeholderStatus: 'Select status',
  firstReward: 'First',
  supplementReturn: 'Supplement',
  contractPaidAmount: 'Contract paid amount',
  sumReturnAmount: 'Total returned',
  introducerName: 'Introducer name',
  regionAgentId: 'Region agent ID',
  shareAmount: 'Share amount',
  channelAgentName: 'Channel agent name',
  introduceAgentId: 'Introducer/Channel ID',
  // 双重订单 DoubleOrder
  addDoubleOrder: 'Add double order',
  sendDeliveryVoucher: 'Send delivery voucher',
  submit: 'Submit',
  changeAddress: 'Change address',
  invoiceConfirm: 'Invoice confirm',
  // 区域客户 RegionCustomers
  introduceCustomIdLabel: 'Introduce customer ID',
  placeholderIntroduceCustomId: 'Select introduce customer ID',
  accountOpenTimeLabel: 'Account open time',
  introducerLevelLabel: 'Introducer channel level',
  placeholderLevel: 'Select level',
  openTimeCol: 'Account open time',
  usedAmount: 'Ordered amount',
  firstContractRatioStr: 'First contract reward ratio',
  cumulativeLevelValue: 'Cumulative level',
  introducerId: 'Introducer ID',
  introducerNameCol: 'Introducer name',
  // 返佣与费用 RebatesAndFees
  purchaseNo: 'Order no.',
  sendNum: 'Dispatch qty',
  purchaseTotalAmount: 'Purchase total',
  renewOrderPayAmount: 'Renew pay amount',
  sendTimeCol: 'Dispatch time',
  unitSubscriptCostAmount: 'Subscription fee',
  rewardRateCol: 'Reward rate',
  rewardGrantFlagVO: 'Reward granted',
  subscriptionFeeRebateAmount: 'Sub fee rebate',
  addServiceFeeAmount: 'Added service fee',
  shareSubscriptionFee: 'Region share sub rebate',
  shareAddServiceFee: 'Region share added fee',
  // 报备复核 ReportConfirm
  reviewBtn: 'Review',
  detailBtn: 'Detail',

  // 下级合伙人档案 SubPartnerProfile
  partnerIdLabel: 'Partner ID',
  placeholderPartnerId: 'Enter partner ID',
  locationLabel: 'Location',
  placeholderLocation: 'Select location',
  partnerName: 'Partner name',
  locationCol: 'Location',
  contactName: 'Contact name',
  contactPhone: 'Contact phone',
  upperAgentId: 'Upper agent ID',
  upperAgentName: 'Upper agent name',
  firstActiveTime: 'First activation time',
  profileDetail: 'Profile detail',
  // 跨区域申诉 CrossRegionalReview
  snCodeLabel: 'Device SN',
  placeholderSnCode: 'Enter device SN',
  dealerLabel: 'Dealer',
  placeholderDealerName: 'Enter dealer name',
  appealStatusLabel: 'Appeal status',
  placeholderAppealStatus: 'Select appeal status',
  appealTimeLabel: 'Appeal time',
  placeholderAppealTime: 'Select appeal time range',
  appealPending: 'Pending',
  appealApproved: 'Approved',
  appealRejected: 'Rejected',
  appealPartialApproved: 'Partially approved',
  currentReviewStatusLabel: 'My review status',
  placeholderCurrentReviewStatus: 'Select review status',
  currentReviewPending: 'Pending',
  currentReviewCompleted: 'Reviewed',
  deviceModel: 'Device model',
  dealerAddress: 'Dealer address',
  activeTimeCol: 'Active time',
  activeProvinceCity: 'Active province/city',
  crossActiveDate: 'Cross-region active date',
  crossActiveProvinceCity: 'Cross-region province/city',
  crossRegionalSubmitterCol: 'Submitted by',
  appealStatusName: 'Appeal status',
  appealSubmitTime: 'Appeal submit time',
  auditTimeCol: 'Audit time',
  auditUser: 'Auditor',
  provinceReviewInfo: 'Provincial review',
  provinceReviewAgentId: 'Provincial agent ID',
  provinceReviewAgentName: 'Provincial agent name',
  provinceReviewResult: 'Provincial result',
  provinceReviewTime: 'Provincial review time',
  provinceReviewer: 'Provincial reviewer',
  provinceReviewRemark: 'Provincial review remark',
  agentReviewInfo: 'Agent review',
  agentReviewAgentId: 'Review agent ID',
  agentReviewAgentName: 'Review agent name',
  agentReviewContact: 'Review agent contact',
  agentReviewResult: 'Agent review result',
  agentReviewTime: 'Agent review time',
  agentReviewer: 'Agent reviewer',
  agentReviewRemark: 'Agent review remark',
  reviewStateChanged: 'Review status changed. Please use the latest detail.',
  auditBtn: 'Audit',
  viewDetail: 'View detail',
  crossAppealTitle: 'Cross-region appeal',
  dealerIdCol: 'Dealer ID',
  campusNameCol: 'Dealer name',
  machineSnLabel: 'Machine SN:',
  dealerAddressLabel: 'Dealer address:',
  activeProvinceCityLabel: 'Soft activate region:',
  activeProvinceCityDialog: 'Activation region',
  crossActiveProvinceCityLabel: 'Cross-region active area:',
  appealContentLabel: 'Application note:',
  proofMaterialLabel: 'Proof material:',
  remarkLabel: 'Remark:',
  placeholderRemarkReject: 'Required when rejected, 2-20 chars',
  placeholderSelectShort: 'Select',
  ruleRemarkLength: 'Reject remark: 2-20 chars',
  auditSuccess: 'Audit success',
  crossReviewSectionBasic: 'Basic info',
  crossReviewSectionYearStats: 'Last 12 months',
  crossReviewSectionAppeal: 'Appeal materials',
  crossReviewSectionAudit: 'Audit',
  crossReviewMachineSn: 'Device SN',
  crossReviewSubmitterContact: 'Submitter contact',
  crossReviewPastYearActivate: 'Activations (last year)',
  crossReviewPastYearCrossActive: 'Cross-region active (last year)',
  crossReviewPastYearLocked: 'Cross-region locked (last year)',
  crossReviewPastYearCities: 'Cross-region cities involved (last year)',
  crossReviewNoProof: 'No proof files',
  auditResultFormLabel: 'Audit result',
  selectAuditResultRule: 'Select audit result',
  appealDescription: 'Application note',
  proofMaterials: 'Proof materials',

  // 运营联系方式 ContactConfig
  contactWayNameLabel: 'Contact name:',
  placeholderContactWayName: 'Enter contact name',
  placeholderContactName: 'Enter contact name',
  contactLevelLabel: 'Contact level:',
  placeholderContactLevel: 'Select level',
  provinceLevel: 'Province',
  cityLevel: 'City',
  districtLevel: 'District',
  applicableRegionLabel: 'Applicable region:',
  placeholderApplicableRegion: 'Select region',
  lastEditTime: 'Last edit time',
  lastEditor: 'Last editor',
  applicableRegionDesc: 'Applicable region',
  addContactConfig: 'Add contact',
  operationRemind: 'Confirm',
  confirmDeleteContact: 'Delete this contact?',
  contactNameLabel: 'Contact name:',
  phoneLabel: 'Phone:',
  placeholderPhone: 'Enter phone number',
  weChatIdLabel: 'WeChat ID:',
  placeholderWeChatId: 'Enter WeChat ID',
  emailLabel: 'Email:',
  placeholderEmail: 'Enter email',
  otherContactLabel: 'Other contact:',
  placeholderOtherContact: 'Enter other contact',
  placeholderSelectLevel: 'Select level',
  placeholderProvinces: 'Select province/city/district',
  addContactTitle: 'Add contact',
  editContactTitle: 'Edit contact',
  ruleContactWayNameRequired: 'Enter contact name',
  ruleContactWayNameLength: 'Name length 2-20 characters',
  ruleContactLevelRequired: 'Select level',
  ruleProvincesRequired: 'Select region',
  ruleContactNameRequired: 'Enter contact name',
  ruleContactNameLength: 'Contact name length 2-20 characters',
  ruleContactNameFormat: 'Contact name: Chinese, English and "·" only',
  rulePhoneFormat: 'Enter valid phone number',
  ruleWeChatIdFormat: 'WeChat ID: start with letter or underscore, 6-20 chars (letters, digits, _, -).',
  ruleEmailFormat: 'Enter valid email',
  atLeastOneContact: 'Enter at least one contact method',
  editSuccess: 'Saved',
  addSuccess: 'Added',
  deleteSuccess: 'Deleted',

  // 区代京东仓发货 AreaJdSend
  agent: 'Agent',
  dispatchOrderNo: 'Dispatch order no.',
  placeholderDispatchOrderNo: 'Enter dispatch order no.',
  createTimeLabel: 'Create time',
  jdProductNameLabel: 'JD product name',
  placeholderJdProductName: 'Enter JD product name',
  orderDeliveryStatus: 'Order delivery status',
  placeholderOrderDeliveryStatus: 'Select status',
  receiverInfo: 'Receiver info',
  placeholderReceiverInfo: 'Enter receiver info',
  dispatchWarehouse: 'Dispatch warehouse',
  placeholderDispatchWarehouse: 'Select warehouse',
  dispatchCloudWarehouse: 'Dispatch cloud warehouse',
  placeholderDispatchCloudWarehouse: 'Select cloud warehouse',
  relatedOrder: 'Related order',
  placeholderRelatedOrder: 'Enter related order',
  waybillNo: 'Waybill no.',
  placeholderWaybillNo: 'Enter waybill no.',
  cloudOutboundNo: 'Cloud outbound no.',
  placeholderCloudOutboundNo: 'Enter cloud outbound no.',
  warehouseTypeName: 'Dispatch cloud warehouse',
  ckOrderNo: 'Dispatch order no.',
  orderDeliveryStatusVO: 'Order delivery status',
  eclpSoNo: 'Cloud outbound no.',
  waitSendNum: 'Pending qty',
  agentWarehouseName: 'Agent warehouse',
  receiverName: 'Receiver',
  receiverMobile: 'Receiver mobile',
  provinceName: 'Province/City',
  receiverAddress: 'Receiver address',
  warehouseName: 'Warehouse',
  purchaseNosFormat: 'Related order',
  createTime: 'Create time',
  sendTime: 'Dispatch time',
  cancelDispatch: 'Cancel dispatch',
  confirmCancelDispatch: 'Confirm cancel dispatch?',
  agentIdCol: 'Agent ID',
  agentNameCol: 'Agent name',
  sendNumCol: 'Dispatched qty',
  logisticsCompany: 'Logistics company',
  logisticsNo: 'Waybill no.',
  confirmCancelDispatchShort: 'Confirm cancel dispatch?',
  // 区域发货 AreaConsignment
  consignmentOrderNo: 'Order no.',
  placeholderConsignmentOrderNo: 'Enter order no.',
  dispatchRegionAgent: 'Dispatch region agent',
  productTypeLabel: 'Product type',
  placeholderProductType: 'Select product type',
  expressNoLabel: 'Express no.',
  placeholderExpressNo: 'Enter express no.',
  dispatchStatusLabel: 'Dispatch status',
  placeholderDispatchStatus: 'Select status',
  statusValid: 'Valid',
  statusCancelled: 'Cancelled',
  dkOrderNoLabel: 'Transfer order no.',
  placeholderDkOrderNo: 'Enter transfer order no.',
  pnOrderNoLabel: 'Pick order no.',
  placeholderPnOrderNo: 'Enter pick order no.',
  snCodePlaceholder: 'Enter device SN',
  snCodeCol: 'Device SN',
  areaConsignmentProductNameCol: 'Product name',
  productNameCol: 'Product name',
  campusIdCol: 'Agent ID',
  campusNameCol: 'Agent name',
  orderNoCol: 'Order no.',
  dkOrderNoCol: 'Transfer order no.',
  pnOrderNoCol: 'Pick order no.',
  dispatchDate: 'Dispatch date',
  expressName: 'Express company',
  expressNoCol: 'Express no.',
  expressStateName: 'Express status',
  isDeleteName: 'Dispatch status',
  accountStatusName: 'Account status',
  useStatusName: 'Device status',
  regionCampusIdCol: 'Dispatch region ID',
  cancelByName: 'Cancelled by',
  cancelTimeCol: 'Cancel time',
  regionCampusNameCol: 'Dispatch region name',
  headOfficeProductNameCol: 'Product name',
  headOfficeOrderQuantityCol: 'Order quantity',
  headOfficeSendQuantityCol: 'Dispatch quantity',
  headOfficeOrderAmountCol: 'Order amount',
  headOfficeIsAutoOrderCol: 'Auto order',
  headOfficeTmallOrderNoCol: 'Tmall order no.',

  // 采购 Purchasing / 赊货 Creditorders
  addPurchase: 'Add purchase',
  addCreditOrder: 'Add credit order',
  provinceAudit: 'Province audit',
  creditOrderTip: 'After order creation you may pay later or partially. See: ',
  viewDetailLink: 'View detail',
  invoiceConfirmTip: 'Confirm that you have received the formal invoice for the order amount?',
  cancelOrderTip: 'Confirm to cancel? Once cancelled, paid amount will be refunded to the agent account and the corresponding futures order quota will be adjusted.',
  confirmResult: 'Confirm result:',
  auditResult: 'Audit result:',
  confirmRemark: 'Confirm remark:',
  auditRemark: 'Audit remark:',
  placeholderConfirmRemark: 'Enter confirm remark',
  agree: 'Agree',
  reject: 'Reject',
  creditConfirmWarn: 'Please confirm that the other party will deliver on credit first and pay after selling the devices!!!',
  orderCreateTimeLabel: 'Order time',
  purchaseQuantity: 'Purchase quantity',
  actualReceivedAmount: 'Amount received',
  receivedGoods: 'Received',
  snMatchSystem: 'Device SN matches system',
  bothConfirmRequired: '*Both must be confirmed',
  changeOrderAddress: 'Change delivery address',

  addLabel: 'Add',
  confirmDeleteConfig: 'Confirm to delete this config?',
  jdParamProductLabel: 'Product:',
  placeholderSelectProduct: 'Select product',
  paramTypeLabel: 'Param type:',
  placeholderSelectParamType: 'Select param type',
  paramValueLabel: 'Param value:',
  placeholderSelectParamValue: 'Select param value',
  mailPayMark: 'Mail pay mark',
  createTimeLabel: 'Create time:',
  typeNameCol: 'Param type',
  conditionCol: 'Condition',
  typeValueNameCol: 'Param value',
  createTimeStrCol: 'Create time',
  createByNameCol: 'Created by',
  editJdParamTitle: 'Edit JD dispatch param config',
  addJdParamTitle: 'Add JD dispatch param config',
  agentLabel: 'Agent:',
  dispatchQuantity: 'Dispatch quantity',
  unitTai: 'unit(s)',
  placeholderMinNum: 'Enter min',
  placeholderMaxNum: 'Enter max',
  deleteSuccess: 'Deleted',
  deleteFailed: 'Delete failed',
  // 区域采购 SecondmentGoods
  regionPurchase: 'Region purchase',
  deductPay: 'Deduct pay',
  fissionAccount: 'Fission account',
  placeholderEnterContent: 'Enter content',
  accountBalance: 'Balance',
  maxDeduct: 'Max deduct',
  confirmPaymentReceived: 'Please confirm the other party has received payment before clicking Agree!!!',
  confirmCancelShort: 'Confirm to cancel?',
  applicationNo: 'Application no.',
  applicantCampusId: 'Applicant agent ID',
  applicantCampusName: 'Applicant agent name',
  fissionDeductAmount: 'Fission deduct amount',
  remainingPayAmount: 'Remaining to pay',
  transferNumCol: 'Transfer qty',
  statusCol: 'Status',
  receiverCol: 'Receiver',
  mobileCol: 'Mobile',
  remarkCol: 'Remark',
  confirmTimeCol: 'Confirm time',
  confirmByCol: 'Confirmed by',
  confirmRemarkCol: 'Confirm remark',
  createTimeCol: 'Create time',
  createByCol: 'Created by',
  orderNoLabelColon: 'Order no.:',
  placeholderOrderNoShort: 'Enter order no.',
  dispatchRegionAgentColon: 'Dispatch region agent:',
  placeholderSelectDispatchRegion: 'Select dispatch region agent',
  statusLabel: 'Status',
  placeholderSelectStatus: 'Select status',
  createTimeLabelShort: 'Create time',
  confirmTimeLabel: 'Confirm time',
  productNameLabelColon: 'Product name:',
  placeholderProductName: 'Enter product name',
  isFissionDeduct: 'Fission deduct',
  optionNo: 'No',
  optionYes: 'Yes',

  // 销售资料 SalesData
  createMaterial: 'Create material',
  materialPreview: 'Preview',
  clickToViewVideo: 'Click to view video',
  pendingPublish: 'Pending',
  published: 'Published',
  publish: 'Publish',
  cancelPublish: 'Unpublish',
  viewInfo: 'View',
  editInfoTitle: 'Edit',
  fillCreateInfo: 'Create',
  nameLabel: 'Name',
  placeholderMaterialName: 'Enter material name',
  materialSort: 'Sort',
  placeholderSort: '1-98',
  catalogDir: 'Catalog',
  uploadMaterial: 'Upload',
  imageMaterial: 'Image',
  videoMaterial: 'Video',
  viewImage: 'View image',
  editImageLabel: 'Edit image',
  replace: 'Replace',
  uploadImageTip: 'Recommended image size: 1080 x 600. Click image to add markers.',
  materialInterpret: 'Description',
  placeholderInterpret: 'Enter description, max 500 characters',
  confirmDeleteMark: 'Delete this marker?',
  insertText: 'Insert text',
  tipTitle: 'Tip',
  confirmPublishMaterial: 'Publish this material?',
  confirmCancelPublishMaterial: 'Unpublish this material?',
  confirmDeleteMaterial: 'Delete this material? This cannot be undone.',
  createNow: 'Create',
  materialNameLabel: 'Material name',
  catalogNameCol: 'Catalog',
  createTimeCol: 'Create time',
  updateTimeCol: 'Last edit time',
  updateByNameCol: 'Last edited by',
  placeholderSelectCatalog: 'Select catalog',
  pleaseUploadMaterial: 'Please upload material',
  pleaseEnterMaterialSort: 'Enter sort order',

  // Compliance 合规
  batchViolationDisable: 'Batch disable',
  studentName: 'Student name',
  studentAccount: 'Student account',
  serviceCenterId: 'Service center ID',
  serviceCenterName: 'Service center name',
  restore: 'Restore',
  restoreUse: 'Restore',
  restoreReason: 'Restore reason',
  violationDisable: 'Disable',
  disableReason: 'Disable reason',
  pleaseEnterReason: 'Enter reason',
  nameOrPhone: 'Name / Phone',
  placeholderNameOrPhone: 'Enter name or phone',
  employeeLearningAccountLabel: 'Employee learning account',
  placeholderEmployeeLearningAccount: 'Enter employee learning account',
  dealerIdLabel: 'Dealer ID',
  placeholderDealerId: 'Select dealer ID',
  learningAccountStatus: 'Account status:',
  placeholderAccountStatus: 'Select account status',
  statusNormal: 'Normal',
  statusDisabled: 'Disabled',
  statusExpired: 'Expired',
  statusViolationDisabled: 'Disabled',
  multiSelect: 'Select',
  nameCol: 'Name',
  phoneCol: 'Phone',
  accountCol: 'Account',
  dealerNameCol: 'Dealer name',
  employeeLearningAccountStatusCol: 'Learning account status',
  disableReasonColon: 'Disable reason:',
  selectedAccountList: 'Selected account list',
  tipTotalCount: '{count} selected',
  studentInfoLabel: 'Student info',
  placeholderStudentInfo: 'Student name / account',
  serviceCenterLabel: 'Service center',
  placeholderServiceCenter: 'Select dealer ID/name',
  accountStatusLabel: 'Account status:',
  userStatusNameCol: 'Account status',
  machineAccountCol: 'Machine account',
  statusPause: 'Paused',

  batchLock: 'Batch lock',
  selectedDeviceList: 'Selected device list',
  machineModel: 'Machine model',
  machineSnCode: 'Machine SN',
  placeholderMachineSnCode: 'Machine SN',
  deviceStatusLabel: 'Device status:',
  deviceStatusPlaceholder: 'Device status',
  statusLocked: 'Locked',
  machineModelCol: 'Machine model',
  machineSnCodeCol: 'Machine SN',
  lockStatusNameCol: 'Device status',
  lock: 'Lock',
  unlock: 'Unlock',
  deviceLock: 'Lock device',
  deviceUnlock: 'Unlock device',
  lockReason: 'Lock reason',
  unlockReason: 'Unlock reason',

  // 总部发货 HeadOfficeShipment
  cloudWarehouseDispatch: 'Cloud warehouse dispatch',
  transferToSuperior: 'Transfer to superior',
  printDispatchOrder: 'Print dispatch order',
  adjustDispatchMethod: 'Adjust dispatch method',
  dispatchOrderConfirm: 'Dispatch order confirm',
  pleaseSelectDispatchOrder: 'Please select dispatch order(s)',
  createDispatchOrderSuccess: 'Dispatch order created.',
  createDispatchOrderFailed: 'Failed to create dispatch order.',
  confirmTransferTo: 'Transfer this order to {name}?',
  confirmTransferToBefore: 'Transfer this order to ',
  confirmTransferToAfter: '?',
  transferLabel: 'Transfer',
  transferGoods: 'Transfer goods',
  orderNoColon: 'Order no.:',
  placeholderOrderNoInput: 'Enter order no.',
  orderStatusLabel: 'Order status:',
  placeholderOrderStatus: 'Select order status',
  createTimeColon: 'Create time:',
  receiverInfoLabel: 'Receiver info:',
  placeholderReceiverInfo: 'Enter receiver info',
  tmallOrderNoLabel: 'Tmall order no.:',
  placeholderTmallOrderNo: 'Enter Tmall order no.',
  placeholderEclpSoNo: 'Enter cloud warehouse outbound no.',
  isAutoOrderLabel: 'Auto order:',
  placeholderIsAutoOrder: 'Select',
  statusConfirmed: 'Confirmed',
  statusDelivering: 'Delivering',
  statusDelivered: 'Delivered',
  statusPartialDeliver: 'Partial',
  statusReceiveConfirm: 'Receive confirmed',
  statusRejectPending: 'Reject pending',
  purchaseOrTransferNo: 'Purchase/Transfer no.:',
  provinceCity: 'Province/City:',
  deliveryAddress: 'Delivery address:',
  agentIdLabel: 'Agent ID:',
  receiverPhone: 'Receiver phone:',
  creditOrderNoCol: 'Credit order no.',
  payStatusLabel: 'Payment Status',
  placeholderPayStatus: 'Select payment status',
  orderStatusLabelCr: 'Order status',
  placeholderOrderStatusCr: 'Select order status',
  payStatusCol: 'Payment status',
  selectConfirmResult: 'Please select confirmation result',
  purchaseNoLabel: 'Purchase order no.',
  placeholderPurchaseNo: 'Enter purchase order no.',
  isNewStandardLabel: 'Is New Standard',
  placeholderIsNewStandard: 'Select Is New Standard',
  creatorLabel: 'Creator',
  placeholderCreator: 'Select person',
  orderTimeLabel: 'Order time',
  lastPayTimeLabel: 'Last payment time',
  buyNumLabel: 'Purchase quantity',
  orderAmountLabel: 'Purchase amount',
  receivedAmountLabel: 'Paid amount',
  submitterLabel: 'Submitter',
  placeholderSubmitter: 'Select person',
  statusLabelPurch: 'Order status',
  placeholderStatusPurch: 'Select order status',
  orderTypeLabel: 'Order type',
  placeholderOrderType: 'Select order type',
  submitTimeLabel: 'Submit time',
  receiverMobileLabel: 'Receiver info',
  placeholderReceiverMobile: 'Enter receiver name or phone',
  dispatchTypesLabel: 'Delivery method',
  placeholderDispatchTypes: 'Multi-select',
  regionInvoiceStatusLabel: 'Invoice confirmation',
  placeholderInvoiceType: 'Select invoice type',
  discountAmountCol: 'Discount amount',
  freightAmountCol: 'Prepaid freight',
  receiveNumCol: 'Dispatch quantity',
  dispatchTypeNameCol: 'Dispatch method',
  lastPayTimeCol: 'Last payment time',
  orderTimeCol: 'Order time',
  submitterNameCol: 'Submitter',
  orderTypeNameCol: 'Order type',
  submitTimeCol: 'Submit time',
  invoiceConfirmCol: 'Invoice confirmation',
  regionConfirmTimeCol: 'Confirm time',
  invoiceStatusInvoiced: 'Invoiced',
  invoiceStatusNotInvoiced: 'Not invoiced',

  // 续费奖励分享 AgentRenewalRewardShare
  sendTimeLabel: 'Delivery time',
  settlementYearMonth: 'Settlement year-month',
  placeholderMonth: 'Select month',
  introduceCustomName: 'Introduce customer name',
  purchaseUnitPriceCol: 'Purchase unit price',
  purchaseTotalPriceCol: 'Purchase total amount',
  deliveryTimeCol: 'Delivery time',
  yearAndMonthCol: 'Settlement year-month',
  shareCampusIdCol: 'Share agent ID',
  shareMoneyCol: 'Share amount',

  // studyMachine (snCodeLabel / placeholderSnCode shared with CrossRegionalReview — see above)
  productTypeLabel: 'Product type',
  placeholderProductType: 'Select product type',
  accountStatusLabelEq: 'Account status:',
  placeholderAccountStatusEq: 'Select account status',
  activateDateLabel: 'Account activation date:',
  dispatchDateLabel: 'Dispatch date:',
  expressCompanyLabel: 'Express company:',
  placeholderExpressCompany: 'Select express company',
  expressNoLabel: 'Tracking no.:',
  placeholderExpressNo: 'Enter tracking no.',
  logisticsStatusLabel: 'Logistics status:',
  placeholderLogisticsStatus: 'Select logistics status',
  stockStatusLabel: 'Stock status:',
  placeholderStockStatus: 'Select stock status',
  statusInactive: 'Inactive',
  statusActive: 'Active',
  statusFrozen: 'Frozen',
  statusSubscribed: 'Subscribed',
  stockNotOut: 'Not out',
  stockOut: 'Out',
  logisticsDetail: 'Logistics detail',
  studyMachineRemark: 'Device remark',
  companyNameLabel: 'Company:',
  selectCompany: 'Select company',
  remarkLabelShort: 'Remark:',
  placeholderRemarkContent: 'Enter content',
  snCodeCol: 'Device SN',
  machineNameCol: 'Product name',
  campusIdCol: 'Agent ID',
  campusNameCol: 'Agent name',
  statusNameCol: 'Account status',
  deviceStatusCol: 'Device status',
  stockStatusCol: 'Stock status',
  firstUseTimeCol: 'First use time',
  activateTimeCol: 'Activation time',
  dispatchTimeCol: 'Dispatch date',
  expressNameCol: 'Express company',
  expressNoCol: 'Tracking no.',
  expressStatusNameCol: 'Logistics status',
  purchaseNoCol: 'Purchase order no.',
  isNewStandardCol: 'Is New Standard',
  contentCol: 'Remark',
  orderedQtyColon: 'Ordered qty:',
  shippedQtyColon: 'Shipped qty:',
  expressCompanyColon: 'Express company:',
  expressNoColon: 'Tracking no.:',
  placeholderFillExpressNo: 'Enter tracking no.',
  transferAreaLeft: 'Available',
  transferAreaRight: 'Selected',
  jdWarehouseReminderTitle: 'JD Warehouse Reminder',
  jdWarehouseReminderContent: 'Selected devices: {snCodes} are shown in JD warehouse, actual shipped devices may differ from SN codes. Continue to confirm?',
  continue: 'Continue',
  ruleSelectProduct: 'Please select product',
  ruleSelectParamType: 'Please select param type',
  ruleSelectParamValue: 'Please select param value',
  ruleFillActivityForm: 'Please fill in activity form',
  saveSuccess: 'Saved successfully',
  saveFailed: 'Save failed',
  saveFailed: 'Save failed',
  shipWarehouseLabel: 'Ship warehouse:',
  placeholderSelectShipWarehouse: 'Select ship warehouse',
  eclsSoNoLabel: 'JD warehouse outbound no.:',
  agentWarehouseLabel: 'Agent warehouse:',
  placeholderCampusAddress: 'Enter campus address',
  productDetail: 'Product detail',
  relatedOrders: 'Related orders',
  orderWaitSendNum: 'Order pending ship qty',
  orderProductCol: 'Order product',
  shipDateCol: 'Ship date',
  shipNumCol: 'Ship qty',
  placeholderShipStatus: 'Ship status',
  placeholderRemark200Chars: 'Enter remark, within 200 chars',
  ruleSelectShipWarehouse: 'Please select ship warehouse',
  ruleEnterReceiverPhone: 'Please enter receiver phone',
  ruleSelectProvinceCity: 'Please select province/city',
  ruleSelectShipStatus: 'Please select ship status',
  ruleEnterShipAddress: 'Please enter ship address',
  placeholderSnOrPurchaseNo: 'Enter SN or purchase no., at least 8 characters for exact search',
  snSearchMinLengthTip: 'Enter at least 8 characters of SN or purchase no. to search',
  equipmentListExport: 'Equipment list export',
  procureAgentBalance: 'Procurement agent balance',
  applyNoLabel: 'Apply no.:',
  statusLabel: 'Status:',
  pendingAudit: 'Pending audit',
  applyAgentLabel: 'Apply agent:',
  auditRegionAgentLabel: 'Audit region agent:',
  teacherNameLabel: 'Teacher name:',
  placeholderTeacherName: 'Enter teacher name',
  teacherPhoneLabel: 'Teacher phone:',
  placeholderTeacherPhone: 'Enter teacher phone',
  childNameLabel: 'Child name:',
  placeholderChildName: 'Enter child name',
  teacherCertNoLabel: 'Teacher cert. no.:',
  placeholderTeacherCertNo: 'Enter teacher cert. no.',
  creatorLabelShort: 'Creator',
  applyRemarkLabel: 'Apply remark:',
  placeholderApplyRemark: 'Enter apply remark',
  createTimeLabelShort: 'Create time:',
  teacherCertMaterialsLabel: 'Teacher cert. and identity materials:',
  commitmentLabel: 'Commitment',
  ruleUploadImage: 'Please upload image',

  // 报告确认 ReportConfirm
  reportAgentLabel: 'Report agent',
  placeholderReportAgent: 'Select report agent',
  reportStatusLabel: 'Status:',
  placeholderReportStatus: 'Select status',
  reportTimeLabel: 'Report time',
  crossTypeLabel: 'Cross-region type',
  placeholderCrossType: 'Select cross-region type',
  reviewResultLabel: 'Review result',
  placeholderReviewResult: 'Select review result',
  reviewCompliant: 'Compliant',
  reviewNonCompliant: 'Non-compliant',
  reviewTimeLabel: 'Review time',
  snActiveStatusLabel: 'Software activation status',
  placeholderSnActiveStatus: 'Select software activation status',
  reportAddressLabel: 'Report activation area',
  placeholderReportAddress: 'Select report activation area',
  finishTimeLabel: 'Finish time',
  createTimeLabel: 'Create time',
  leaderAgentLabel: 'Owner area agent',
  placeholderLeaderAgent: 'Select owner area agent',
  isAuditLabel: 'Need review',
  placeholderIsAudit: 'Select need review',
  optionAll: 'All',
  optionYes: 'Yes',
  reviewDialogTitle: 'Review',
  snCodeColon: 'SN:',
  ownerDealerColon: 'Owner dealer:',
  reportAddressColon: 'Report area:',
  dealerAddressColon: 'Dealer address:',
  reportAgentColon: 'Report agent:',
  leaderAgentColon: 'Leader agent:',
  snActiveStatusColon: 'Software activation:',
  statusColon: 'Status:',
  crossTypeColon: 'Cross type:',
  reportByColon: 'Report by:',
  reportTimeColon: 'Report time:',
  lastUpdateColon: 'Last update:',
  paymentVoucher: 'Payment voucher:',
  chatRecord: 'Chat record:',
  reportReasonColon: 'Report reason:',
  operTimeCol: 'Oper time',
  operByCol: 'Operator',
  reportStatusCol: 'Report status',
  reviewResultCol: 'Review result',
  reviewResultStrong: 'Review result:',
  reviewRemarkStrong: 'Review remark:',
  submitBtn: 'Submit',
  leaderAgentIdCol: 'Owner agent ID',
  leaderAgentNameCol: 'Agent name',
  reportAgentAddressCol: 'Report area',
  reportAgentIdCol: 'Report agent ID',
  reportAgentNameCol: 'Report agent name',
  crossTypeNameCol: 'Cross-region type',
  reportStatusNameCol: 'Status',
  snActiveStatusNameCol: 'Software activation',
  snActiveTimeCol: 'Software activation time',
  reviewResultNameCol: 'Review result',
  reportReasonCol: 'Report reason',
  reportByNameCol: 'Report by',
  reportTimeCol: 'Report time',
  ownerCampusIdCol: 'Owner dealer ID',
  ownerCampusNameCol: 'Dealer name',
  ownerCampusAddressCol: 'Dealer address',
  createTimeColReport: 'Create time',
  updateTimeCol: 'Last update',
  reviewTimeCol: 'Review time',
  reviewByNameCol: 'Reviewer',
  finishTimeCol: 'Finish time',
  finishByNameCol: 'Finished by',
  pleaseFillReviewResult: 'Please fill in review result',
  pleaseFillReviewRemark: 'Please fill in review remark',
  pleaseFillCancelDuration: 'Please enter cancellation duration',
  cancelDurationMonthsRule: 'Duration must be an integer from 1 to 12 (months)',
  cancelCrossRegionQuotaLabel: 'Cancel dealer cross-region activation quota:',
  cancelDurationMonthsLabel: 'Cancellation duration (months):',
  placeholderReviewRemarkInput: 'Enter content',
  pdfFileAlt: 'PDF file',
  downloadFileTitle: 'Download',
  previewFileTitle: 'Preview',
  pdfUrlMissing: 'PDF URL is missing',
  reviewBtn: 'Review',
  snCodeShort: 'SN',

  // 儿童设备 ChildrenDevice
  childApplyNoLabel: 'Application no.:',
  placeholderApplyNo: 'Enter application no.',
  auditRegionAgentLabel: 'Audit region agent',
  teacherNameLabel: 'Teacher name:',
  placeholderTeacherName: 'Enter teacher name',
  teacherPhoneLabel: 'Teacher phone:',
  placeholderTeacherPhone: 'Enter teacher phone',
  teacherCertNoLabel: 'Teacher cert. no.:',
  placeholderTeacherCertNo: 'Enter teacher cert. no.',
  createTimeLabelColon: 'Create time:',
  auditTimeLabelColon: 'Audit time:',
  statusLabelChild: 'Status:',
  placeholderStatusChild: 'Select status',
  statusPendingAudit: 'Pending audit',
  statusAuditPass: 'Approved',
  statusAuditReject: 'Rejected',
  deviceSnLabel: 'Device SN:',
  placeholderSnCodeSearch: 'Search by device SN',
  childAccountNoCol: 'Application no.',
  childNameCol: 'Child name',
  teacherNameCol: 'Teacher name',
  teacherPhoneCol: 'Teacher phone',
  teacherCertificateNoCol: 'Teacher cert. no.',
  auditRemarkCol: 'Audit remark',
  auditTimeColChild: 'Audit time',
  auditByNameCol: 'Auditor',
  regionCampusIdColChild: 'Audit region agent ID',
  regionCampusNameColChild: 'Audit region agent name',

  // 双订单 DoubleOrder
  isVoucherIssuedLabel: 'Voucher issued',
  placeholderIsVoucherIssued: 'Select voucher issued',
  voucherIssuedCol: 'Voucher issued',
  relatedAgentLabel: 'Related agent',
  placeholderRelatedAgent: 'Select related agent',
  relatedAgentIdCol: 'Related agent ID',
  relatedAgentNameCol: 'Related agent name',
  placeholderDispatchMethod: 'Select dispatch method',
  confirmTimeCol: 'Confirm time',

  // 收货 TakeDelivery
  newLading: 'New lading',
  ladingNoLabel: 'Lading no.',
  placeholderLadingNo: 'Enter lading no.',
  warehouseLabel: 'Warehouse',
  placeholderWarehouse: 'Select warehouse',
  sendStatusLabel: 'Dispatch status',
  placeholderSendStatus: 'Select dispatch status',
  warehouseOrderNoLabel: 'Warehouse order no.',
  placeholderWarehouseOrderNo: 'Enter warehouse order no.',
  cancelShipment: 'Cancel shipment',
  confirmCancelLading: 'Confirm cancel lading?',
  prepayFreight: 'Prepay freight',
  ladingNoCol: 'Lading no.',
  warehouseNameCol: 'Warehouse',
  warehouseOrderNoCol: 'Warehouse order no.',
  sendStatusNameCol: 'Dispatch status',
  receivedAmountColLading: 'Prepay freight',
  extractNumCol: 'Extract quantity',

  // 小松鼠少年 SquirrelJuvenile
  searchUserLabel: 'Search user',
  placeholderSearchUser: 'Enter user',
  recommendStudentNameCol: 'Recommend student',
  studentPhoneCol: 'Phone',
  recommendTimeCol: 'Recommend time',
  auditStatusCol: 'Audit status',
  auditPassTimeCol: 'Audit pass time',
  voteNoCol: 'Vote no.',
  voteNumCol: 'Votes',
  rankCol: 'Rank',
  tabPendingAudit: 'Pending audit',
  tabAuditPass: 'Approved',
  confirmWriteOffGift: 'Confirm write off gift?',
  tipTitle: 'Tip',
  updateByNameColSq: 'Operator',
  campusIdColSq: 'Dealer ID',
  campusNameColSq: 'Dealer name',
  writeOffSuccess: 'Write-off success',
  // checkSquirrelJuvenile 报名审核
  signupAuditTitle: 'Sign-up audit',
  playerDetailTitle: 'Player detail',
  voteNoLabel: 'No.',
  rankLabel: 'Rank',
  voteNumLabel: 'Votes',
  distancePrevLabel: 'To previous',
  storyWithSquirrelTitle: 'My story with Squirrel',
  auditPassBtn: 'Approve',
  rejectApplyBtn: 'Reject',
  auditDialogTitle: 'Audit',
  confirmAuditPass: 'Confirm approval',
  rejectReasonTitle: 'Reject reason',
  rejectReasonLabel: 'Reject reason:',
  placeholderRejectReason: 'Enter reject reason',
  confirmRejectBtn: 'Confirm reject',
  ruleRejectReasonRequired: 'Please enter reject reason',
  auditPassSuccess: 'Approved',
  rejectSuccess: 'Rejected',
  operationFailed: 'Operation failed',

  // 仓间借还货 LoanAndReturn
  newTransfer: 'New transfer',
  transferOrderNoLabel: 'Transfer order no.',
  placeholderTransferOrderNo: 'Enter transfer order no.',
  outCampusLabel: 'Out agent',
  placeholderOutCampus: 'Enter agent',
  inCampusLabel: 'In agent',
  placeholderInCampus: 'Enter agent',
  docStatusLabel: 'Doc status',
  placeholderDocStatus: 'Select doc status',
  relationTransferOrderLabel: 'Related transfer',
  placeholderRelationTransfer: 'Enter related transfer',
  outWarehouseLabel: 'Out warehouse',
  inWarehouseLabel: 'In warehouse',
  placeholderWarehouseInput: 'Enter warehouse',
  warehouseTransferNoLabel: 'Warehouse transfer no.',
  placeholderWarehouseTransferNo: 'Enter warehouse no.',
  docStatusPending: 'Pending',
  docStatusRejected: 'Rejected',
  docStatusCancelled: 'Cancelled',
  docStatusApproved: 'Approved',
  sendStatusNew: 'New',
  sendStatusInitial: 'Initial',
  sendStatusComplete: 'Complete',
  sendStatusCancelSuccess: 'Cancelled',
  sendStatusProduceFail: 'Failed',
  confirmCancelShort: 'Confirm cancel?',
  transferOrderNoCol: 'Transfer order no.',
  transferNumCol: 'Transfer qty',
  transferredNumCol: 'Transferred qty',
  outCampusIdCol: 'Out agent ID',
  outCampusNameCol: 'Out agent name',
  inCampusIdCol: 'In agent ID',
  inCampusNameCol: 'In agent name',
  outWarehouseNameCol: 'Out warehouse',
  inWarehouseNameCol: 'In warehouse',
  relationOrderNoCol: 'Related transfer',
  warehouseTransferNoCol: 'Warehouse transfer no.',
  orderStatusNameCol: 'Doc status',

  // 云仓产品 CloudProduct
  totalInventoryCol: 'Total inventory',
  availableInventoryCol: 'Available inventory',
  totalInventoryLabel: 'Total inventory',
  availableInventoryLabel: 'Available inventory',
  partnerWarehouseCol: 'Partner warehouse',

  // 合作伙伴 CustomerOrderDetails
  placeholderIntroduceCustomerSearch: 'Enter customer ID or name',
  orderTimeRangeLabel: 'Order time',
  placeholderOrderTimeRange: 'Select order time range',
  deliveryTimeRangeLabel: 'Delivery time',
  placeholderDeliveryTimeRange: 'Select delivery time range',
  introduceCustomerIdCol: 'Introduce customer ID',
  introduceCustomerNameCol: 'Introduce customer name',
  purchaseNoLabel: 'Purchase order no.',
  partnerCustomerOrderTypeNameCol: 'Purchase type',
  dispatchTypeNameCol: 'Delivery method',
  partnerCustomerPayStatusCol: 'Payment status',
  statusCol: 'Order status',
  productNameCol: 'Product name',
  purchaseQuantity: 'Purchase quantity',
  receiveNumCol: 'Delivery quantity',
  purchaseUnitPriceCol: 'Unit price',
  orderAmount: 'Total amount',
  cashAmountCol: 'Cash amount',
  orderTimeCol: 'Order time',
  lastDispatchTimeCol: 'Delivery time',
  partnerCampusIdCol: 'Partner campus ID',
  partnerCampusNameCol: 'Partner campus name',

  // 原型机管理 PrototypeManagement
  machineAccountLabel: 'Machine account:',
  placeholderMachineAccount: 'Enter machine account',
  searchStudentLabel: 'Search student:',
  placeholderSearchStudent: 'Enter account or student name',
  accountActiveDateLabel: 'Account active date:',
  placeholderAccountActiveDateRange: 'Select account active date range',
  placeholderSnCode: 'Enter SN code',
  accountStatusLabelPrototype: 'Account status:',
  placeholderAccountStatus: 'Select account status',
  statusActivated: 'Activated',
  statusFrozen: 'Frozen',
  statusSubscribed: 'Subscribed',
  machineAccountCol: 'Machine account',
  prototypeProductNameCol: 'Product name',
  prototypeStatusCol: 'Status',
  accountActiveDateCol: 'Account active time',
  certificateAreaCol: 'Certified area',
  accountUserCol: 'Student account',
  userNameCol: 'Student name',
  periodValidityCol: 'Account validity',
  markPrototype: 'Mark prototype',
  prototypeAccountRenew: 'Prototype account renewal',
  accountPhoneRebind: 'Account phone rebind',
  unmarkPrototype: 'Unmark prototype',
  productModelLabel: 'Product model:',
  deviceSnLabel: 'Device SN:',
  placeholderDeviceSn: 'Enter device SN',
  prototypeTypeLabel: 'Prototype type:',
  placeholderPrototypeType: 'Select prototype type',
  dispatchedPrototypeCnt: 'Dispatched prototype cnt:',
  signedPrototypeCnt: 'Signed prototype cnt:',
  markablePrototypeCnt: 'Markable prototype cnt:',
  traineeAccountCol: 'Trainee account',
  studentNameColPrototype: 'Student name',
  schoolIdCol: 'Campus ID',
  schoolNameCol: 'Campus name',
  notePrototypeLabel: 'Note:',
  notePrototype1: '1. Once marked as prototype, the device cannot be changed.',
  notePrototype2: '2. Prototypes are for experience and display only, not for sale.',
  notePrototype3: '3. Each prototype can bind one account; if multiple accounts are bound, choose one to keep and others will be unbound.',
  prototypeAccountRenewTitle: 'Prototype account renewal',
  prototypeSnLabel: 'Prototype SN:',
  learningMachineAccountLabel: 'Machine account:',
  currentCertAreaLabel: 'Current certified area:',
  accountActiveTimeLabel: 'Account active time:',
  accountValidityLabel: 'Account validity:',
  renewBtn: 'Renew',
  accountPhoneRebindTitle: 'Account phone rebind',
  accountNoLabel: 'Machine account no.:',
  agentIdLabel: 'Agent ID:',
  agentNameLabel: 'Agent name:',
  originalPhoneLabel: 'Original phone:',
  newPhoneLabel: 'New phone:',
  verifyCodeLabel: 'Verify code:',
  placeholderOriginalPhone: 'Enter original phone',
  placeholderNewPhone: 'Enter new phone',
  placeholderVerifyCode: 'Enter verify code',
  sendVerifyCode: 'Send code',
  resendVerifyCode: 'Resend',
  resendAfterSeconds: 's to resend',
  nextStep: 'Next',
  rulePhoneRequired: 'Enter phone number',
  ruleVerifyCodeRequired: 'Enter verify code',
  ruleDeviceSnRequired: 'Enter device SN',
  pleaseVerifySnFirst: 'Verify device SN first',
  pleaseSelectPrototypeType: 'Select prototype type',
  pleaseSelectTrainee: 'Select trainee',
  confirmMarkPrototypeTip: 'Once marked as prototype, the device cannot be changed.',
  markSuccess: 'Marked successfully',
  renewFail: 'Renewal failed',
  renewSuccess: 'Renewed successfully',
  pleaseEnterNewPhone: 'Enter new phone number',
  verifyCodeSent: 'Verify code sent',
  rebindSuccess: 'Rebind success',
  rebindFail: 'Rebind failed',
  submitFail: 'Submit failed',

  // 教材目录管理 CatalogManagement
  addCatalogBtn: 'Add catalog',
  catalogSortCol: 'Sort',
  catalogNameLabelCol: 'Catalog name',
  materialCountCol: 'Material count',
  addCatalogTitle: 'Add catalog',
  editCatalogTitle: 'Edit catalog',

  // 自动订单配置 AutomaticOrderConfiguration
  addProductRatioBtn: 'Add product ratio',
  autoOrderProductRatioMaintain: 'Auto Order Product Ratio Maintenance',
  autoOrderRatioTip: '*Please maintain accurate ratios for each model. Auto orders will allocate amounts based on these ratios! All ratios must total 100%.',
  ratioLabel: 'Ratio',
  totalRatioLabel: 'Total',
  updateLogLabel: 'Update log:',
  ratioValueError: 'Please enter valid ratio values: integers from 1 to 100, total must equal 100%',
  placeholderRatio: 'Please enter ratio',
  campusIdColShort: 'Agent ID',
  modelNameCol: 'Product model',
  activeStatusCol: 'Product status',
  productRatioCol: 'Product ratio (total=100)',
  lastUpdateTimeCol: 'Last update time',
  lastUpdateByCol: 'Last updated by',

  // 合作伙伴权益 Partner Equity
  partnerTypeCol: 'Partner type',
  investmentAmountCol: 'Total investment',
  initialPaymentCol: 'Initial payment',
  additionalPaymentCol: 'Intro additional payment',
  investmentRateCol: 'Intro investment rate',
  totalPaymentCol: 'Total payment',
  equityPeriodCol: 'Equity period',
  paymentDeadlineCol: 'Payment deadline',
  equityStatusCol: 'Equity status',
  withdrawalRateCol: 'Withdrawal rate',
  commissionRateCol: 'Commission rate',
  renewalRateCol: 'Renewal rate',

  // 体验机管理 Experience
  experienceDealerIdCol: 'Dealer ID',
  experienceDealerNameCol: 'Dealer name',
  experienceCityCol: 'Area',
  experienceLimitCol: 'Experience limit',
  experienceUsedLimitCol: 'Used limit',
  softActiveNumCol: 'Software activated',
  grantExperienceLimit: 'Grant experience limit',
  experienceMonthLimitLabel: 'Monthly grant limit:',
  grantExperienceDialogTitle: 'Grant experience limit',
  experienceDealerIdLabel: 'Dealer ID:',
  experienceDealerNameLabel: 'Dealer name:',
  experienceRemainLimitLabel: 'Remaining limit this month:',
  experienceGrantAmountLabel: 'Grant amount:',
  placeholderGrantAmount: 'Enter grant amount',
  experienceOverDialogTitle: 'Experience limit used up',
  experienceOverMessage: 'Your monthly experience grant limit has been used up.',
  msgGrantAmountRequired: 'Please enter grant amount',
  msgGrantAmountMin: 'Grant amount must be at least 1',
  msgGrantAmountMax: 'Grant amount cannot exceed monthly limit {count}',
  msgGrantSuccess: 'Grant success',
  msgGrantAmountEmpty: 'Grant amount cannot be empty',
  exportExperienceName: 'Experience management',

  // 信用订单 Creditorders
  receiptConfirmTitle: 'Receipt confirmation',
  receivedRadio: 'Received',
  deviceSnMatchRadio: 'Device SN matches system',
  bothConfirmRequired: '*Both must be confirmed',
  confirmCancelQuestion: 'Confirm to cancel?',
  payConfirmDialogTitle: 'Notice',
  payDeductTip: 'This payment will deduct:',
  voucherAccountPayLabel: 'Voucher Bonus Account:',
  cashAccountPayLabel: 'Cash account:',
  goldAccountPayLabel: 'Gold account:',
  deliveryVoucherPayLabel: 'Delivery voucher account:',
  yuan: ' CNY',
  provinceNoCreditMsg: 'Province agent cannot use credit; please use online order.',
  onlyDealerCreditMsg: 'Only dealers can apply for credit; please use online order.',
  creditQueryFailed: 'Query failed',
  creditSubmitFailed: 'Submit failed',
  creditSubmitSuccess: 'Submit success',
  pleaseConfirmReceived: 'Please confirm receipt',
  pleaseConfirmDeviceSn: 'Please confirm device SN matches system',
  creditConfirmSuccess: 'Confirm success',
  creditConfirmFailed: 'Confirm failed',
  creditCancelSuccess: 'Cancel success',
  creditCancelFailed: 'Cancel failed',
  // 运费弹窗 LadingFreightFeesDialog
  freightPlanTitle: 'Freight plan:',
  freightPlan1: 'Option 1: Collect on delivery:',
  freightPlan1Desc: '(Pay to courier on receipt; amount may vary by ~20%)',
  freightPlan2: 'Option 2: Prepay freight:',
  freightPlan2Desc: '(Original ¥{original}; pay with order; HQ handles disputes)',
  freightPlan2DescShort: '(Original ¥{original}; pay with order; HQ handles disputes)',
  freightTipsTitle: 'Order qty <10; default is collect on delivery. Prepay option available for freight discount. Note:',
  freightRule1: '1. COD discount per JD warehouse agreement; current 65% off; subject to change.',
  freightRule2: '2. Prepay is optional; if declined, pay COD to courier on delivery.',
  freightRule3: '3. If order merged and meets free-shipping (≥10 units), prepaid freight will be refunded.',
  chargeItemCol: 'Item',
  unitPriceCol: 'Unit price',
  qtyCol: 'Qty',
  amountCol: 'Amount',
  discountCol: 'Discount',
  discountedAmountCol: 'Discounted amount',
  payFreightCollect: 'Pay (COD)',
  payFreightPrepay: 'Pay (Prepay)',
  dispatchSuccess: 'Dispatched',
  dispatchFailed: 'Dispatch failed',
  operateTooFrequent: 'Please avoid operating too frequently',

  creditOrderRightsModifyWarn: 'This order uses benefits and cannot be modified; you may cancel and reorder.',
  creditPayFailed: 'Payment failed',
  paySuccessTitle: 'Payment success',
  payFailTitle: 'Payment failed',
  pleaseSelectConfirmResult: 'Please select confirm result',
  deductPaySuccess: 'Payment success',

  // CreditordersCreation
  creditOrderNoLabel: 'Order no.:',
  creditApplyAgentLabel: 'Apply agent:',
  createByLabel: 'Created by:',
  receiveRegionAgentLabel: 'Receive region agent:',
  agentWarehouseLabel: 'Agent warehouse:',
  receiverLabel: 'Receiver:',
  receiverPhoneLabel: 'Receiver phone:',
  provincesLabel: 'Province/City/District:',
  addressLabel: 'Address:',
  remarkLabelShort: 'Remark:',
  placeholderCampusAddress: 'Enter campus address',
  placeholderRemark200: 'Enter remark, within 200 chars',
  ruleOrderTypeRequired: 'Please enter purchase type',
  ruleReceiverRequired: 'Please enter receiver',
  ruleMobileRequired: 'Mobile is required',
  ruleProvincesRequired: 'Please select province/city/district',
  ruleDispatchTypeRequired: 'Please select method',
  ruleAddressRequired: 'Please enter address',
  ruleWarehouseRequired: 'Please select agent warehouse',
  addGoodsBtn: '+ Add goods',
  goodsDetailTitle: 'Goods detail',
  addDiscountBtn: '+ Select discount',
  selectedDiscountDesc: '{selected} selected / {total} available',
  availableDiscountDesc: '{total} available',
  discountInfoTitle: 'Discount info',
  logisticsDetailTitle: 'Logistics detail',
  paymentDetailTitle: 'Payment detail',
  auditDetailTitle: 'Audit detail',
  priorityPurchaseRightText: 'Priority purchase benefit',
  discountRightText: 'Purchase discount benefit:',
  originalTotalLabel: 'Original total:',
  discountAmountLabel: 'Discount: ¥',
  purchaseAmountLabel: 'Purchase amount:',
  selectDiscountTitle: 'Select discount',
  addGoodsTitle: 'Add goods',
  stockRemindTitle: 'Stock reminder',
  stockRemindContentBefore: 'Stock status: ',
  stockRemindContentAfter: '. Delivery may take longer. You may go back to choose other goods, or continue and wait for delivery.',
  continueOrderBtn: 'Continue order',
  reselectGoodsBtn: 'Reselect goods',
  confirmDeleteQuestion: 'Confirm delete?',
  creditCreationProductNameCol: 'Product name',
  creditCreationUnitPriceCol: 'Unit price',
  creditCreationQuantityCol: 'Quantity',
  creditCreationAmountCol: 'Amount',
  paySerialNoCol: 'Pay serial no.',
  payMethodCol: 'Pay method',
  payTimeCol: 'Pay time',
  payAmountCol: 'Pay amount',
  operatorCol: 'Operator',
  dispatchDateCol: 'Dispatch date',
  expressCompanyCol: 'Express company',
  expressNoCol: 'Express no.',
  logisticsStatusCol: 'Logistics status',
  dispatchNumCol: 'Dispatch qty',
  auditTimeCol: 'Audit time',
  auditorCol: 'Auditor',
  auditorCampusIdCol: 'Auditor campus ID',
  auditorCampusNameCol: 'Auditor campus name',
  auditResultCol: 'Audit result',
  auditRemarkCol: 'Audit remark',
  rightNameCol: 'Right name',
  applicableGoodsCol: 'Applicable goods',
  expiryTimeCol: 'Expiry time',
  rightCodeCol: 'Right code',
  deleteSuccessMsg: 'Deleted.',
  pleaseSelectGoodsFirst: 'Please select goods first',
  saveSuccess: 'Save success',
  msgCorrectMobileRequired: 'Please enter a valid mobile number',
  msgDetailedAddressRequired: 'Please enter detailed delivery address, e.g. Province City District Street No.',
  msgAddProductQuantity: 'Please add product quantity',
  msgProductQuantityRequired: 'Product quantity must be greater than 0',

  // 双重订单 DoubleOrder
  sendVoucherDialogTitle: 'Send delivery voucher',
  sendVoucherConfirmContent: 'Once the voucher is issued in advance, this dual order cannot be modified. Confirm to issue?',
  invoiceConfirmDialogTitle: 'Invoice confirmation',
  invoiceConfirmContent: 'Confirm that you have received the formal invoice for this order?',
  cancelOrderConfirmContent: 'Confirm to cancel? Once cancelled, payment will be refunded to the agent account and futures order quota will be adjusted.',
  changeAddressTitle: 'Change delivery address',
  placeholderReceiver: 'Receiver',
  placeholderReceiverPhone: 'Receiver phone',
  placeholderSelectAgentWarehouse: 'Select agent warehouse',
  placeholderAddress: 'Enter/select address',
  ruleReceiverFill: 'Please enter receiver',
  ruleMobileValid: 'Please enter a valid mobile number',
  ruleWarehouseRequiredDouble: 'Please select agent warehouse',
  ruleAddressFill: 'Please enter address',
  voucherIssuedCannotCancel: 'Voucher already issued for this order; cannot cancel.',
  distributeVoucherWarning: 'Please ship first for auto voucher return, or apply to cancel via DingTalk; cannot issue voucher in advance.',
  distributeSuccess: 'Issued successfully',
  promoteAccountPayLabel: 'Promotion account:',
  placeholderEnterReceiverPhone: 'Enter receiver phone',
  placeholderFillReceiver: 'Enter receiver',
  placeholderSelectProvinces: 'Select province/city/district',
  selectWarehouseFirst: 'Please select agent warehouse',
  selectAddressFirst: 'Please select/enter address',
  modifySuccess: 'Modify success',
  modifyFailed: 'Modify failed',
  receivedAmount30PercentTip: 'Received amount must be ≥30% of purchase amount to submit.',

  // 采购创建 PurchaseCreation
  purchaseOrderNoLabel: 'Purchase no.:',
  purchaseUnitLabel: 'Purchase unit:',
  purchaseTypeLabel: 'Purchase type:',
  placeholderSelectPurchaseType: 'Select purchase type',
  dispatchTypeLabel: 'Dispatch type:',
  placeholderSelectDispatchType: 'Select dispatch type',
  dispatchRegionAgentLabel: 'Dispatch region agent:',
  freightDetailTitle: 'Freight detail',
  saveAndPayBtn: 'Save and pay',
  chargeItemCol: 'Charge item',
  freightUnitPriceCol: 'Unit price',
  freightQuantityCol: 'Quantity',
  freightDetailAmountCol: 'Amount',
  freightDiscountCol: 'Discount',
  dispatchChangeHeadOffice: 'For samples, subscription cards, accessories, please select [Head office dispatch].',
  dispatchChangeConfirmHeadOffice: 'Change dispatch type to [Head office dispatch]?',
  dispatchChangeLimitHeadOffice: 'This limited model requires [Head office dispatch].',
  dispatchChangeConfirmLimitHeadOffice: 'Change dispatch type to [Head office dispatch]?',
  dispatchChangeRegion: 'For learning devices etc., please select [Region agent dispatch].',
  dispatchChangeConfirmRegion: 'Change dispatch type to [Region agent dispatch]?',
  dialogTitleTip: 'Notice',
  dialogTitleConfirm: 'Confirm',
  confirmDeleteContent: 'Confirm delete?',
  priceRiseCycleTip: 'You are in a price increase period. Please pay the price increase amount of {amount} yuan for this order so it can proceed to the next audit.',
  saveSuccessExclaim: 'Saved successfully!',
  cancelSaveMsg: 'Save cancelled',
  // addClassModal Add goods dialog
  productInstruction: 'Product manual',
  unitPriceShort: 'Unit price',
  viewAction: 'View',
  suggestedRetailPrice: '(Suggested retail price: {price} yuan)',
  // DoubleOrderCreation
  isDualOrderLabel: 'Dual order:',
  relatedAgentLabel: 'Related agent:',
  placeholderRelatedAgent: 'Select related agent',
  placeholderFilterAgent: 'Enter agent ID or name to filter',
  ruleRelatedAgentRequired: 'Please select related agent',
  dualOrderYesDefault: 'Yes',
  // SecondmentDetails
  applicationNoLabel: 'Application no.:',
  applicantAgentLabel: 'Applicant agent:',
  receiveRegionAgentLabel: 'Receive region agent:',
  inventoryQty: 'Inventory',
  // CloudStorageFlow
  storageFlowWarehouseLabel: 'Warehouse',
  placeholderStorageFlowWarehouse: 'Select warehouse',
  storageFlowCompleteTimeLabel: 'Complete time',
  storageFlowModelTypeLabel: 'Product type',
  placeholderStorageFlowModelType: 'Select product type',
  storageFlowOrderInfoLabel: 'Order no.',
  placeholderStorageFlowOrderInfo: 'Enter order no.',
  storageFlowBusinessTypeLabel: 'Business type',
  placeholderStorageFlowBusinessType: 'Select business type',
  storageInbound: 'Inbound',
  storageOutbound: 'Outbound',
  storageFlowWarehouseNameCol: 'Warehouse name',
  storageFlowOrderInfoCol: 'Order no.',
  storageFlowTransferNoCol: 'Transfer no.',
  storageFlowProductNameCol: 'Product name',
  storageFlowPurchaseQtyCol: 'Purchase qty',
  storageFlowInCountCol: 'Inbound qty',
  storageFlowOutCountCol: 'Outbound qty',
  storageFlowReceiveAgentIdCol: 'Receive agent ID',
  storageFlowReceiveAgentNameCol: 'Receive agent name',
  storageFlowShipAgentIdCol: 'Ship agent ID',
  storageFlowShipAgentNameCol: 'Ship agent name',
  storageFlowCompleteTimeCol: 'Complete time',
  storageFlowInboundTotal: 'Inbound total',
  storageFlowOutboundTotal: 'Outbound total',
  exportUrlNotExist: 'Export URL not found',
  // AllocationCreation / DeliveryCreation
  outCampusIdLabel: 'Out agent ID:',
  outCampusNameLabel: 'Out agent name:',
  outWarehouseLabel: 'Out warehouse:',
  inCampusIdLabel: 'In agent ID:',
  inCampusNameLabel: 'In agent name:',
  inWarehouseLabel: 'In warehouse:',
  relationTransferLabel: 'Related transfer:',
  placeholderSelectOutWarehouseFirst: 'Select out warehouse and enter in agent ID',
  ruleOutWarehouseRequired: 'Please select out warehouse',
  ruleInCampusIdRequired: 'Please enter in agent ID',
  ruleInWarehouseRequired: 'Please select in warehouse',
  warehouseAvailableInventoryCol: 'Available inventory',
  transferNumCol: 'Transfer qty',
  extractNumColShort: 'Extract qty',
  // AllocationDetail
  orderStatusCol: 'Order status',
  cloudWarehouseTransferNoLabel: 'Cloud warehouse transfer no.:',
  sendStatusCol: 'Ship status',
  transferOutInfo: 'Transfer out info',
  transferInInfo: 'Transfer in info',
  productInfoLabel: 'Product info',
  logisticsInfoLabel: 'Logistics info',
  sendDateCol: 'Ship date',
  sendQtyCol: 'Ship qty',
  msgWarehouseInOutMismatch: 'In and out warehouse must match',
  msgSelectWarehouseFirst: 'Please select warehouse',
  msgTransferNumExceedInventory: 'Transfer qty cannot exceed available inventory',
  msgExtractNumExceedInventory: 'Extract qty cannot exceed available inventory',
  msgAddressMin8Chars: 'Delivery address must have at least 8 Chinese characters',
  ruleWarehouseBelongRequired: 'Please select warehouse',

  // CloudStorageDetail
  modelTypeLabel: 'Product type',
  placeholderModelType: 'Select product type',
  inboundWarehouseLabel: 'Inbound warehouse',
  placeholderInboundWarehouse: 'Select inbound warehouse',
  inboundTimeLabel: 'Inbound time',
  deviceSnCodeLabel: 'Device SN',
  cloudStorageDetailOrderNoLabel: 'Order number',
  placeholderCloudStorageDetailOrderNo: 'Enter order number',

  // CloudDeliveryOrder
  warehouseShippingSeqTitle: 'Warehouse Shipping Sequence',
  warehouseShippingSeqTip: 'When the default warehouse stock is insufficient, it will search other warehouses in order. Changing the default warehouse affects freight settlement. Please adjust carefully.',
  defaultWarehouseLabel: 'Default warehouse',
  modifyRecordTitle: 'Modification record',
  operatorLabel: 'Operator:',
  modifyTimeLabel: 'Modify time:',
  afterModifyWarehouseSeq: 'Warehouse sequence after modification',
  beforeModifyWarehouseSeq: 'Warehouse sequence before modification',
  getDetailFailed: 'Failed to get details',
  operatorCol: 'Operator',

  // Procure1Pay
  purchaseOrderNoColon: 'Order no.: ',
  orderTimeColon: 'Order time: ',
  purchaseQtyColon: 'Purchase qty: ',
  purchaseAmountColon: 'Purchase amount: ',
  paidAmountColon: 'Paid amount: ',
  maxDeductible: 'Max deductible: ',

  // SchoolApplication
  schoolName: 'School name',
  schoolNamePlaceholder: 'Enter school name',
  schoolNameTip: 'Enter full public school name, no abbreviations',
  provinceCityDistrictLabel: 'Province/City/District',
  provinceCityDistrictPlaceholder: 'Select province/city/district',
  detailAddressLabel: 'Detail address',
  detailAddressPlaceholder: 'Enter detail address',
  schoolStage: 'School stage',
  studentScale: 'Student scale',
  remarkOptional: 'Optional',
  submitNow: 'Submit now',
  stagePrimary: 'Primary',
  stageJunior: 'Junior high',
  stageSenior: 'Senior high',
  stageOther: 'Other',
  scaleUnder2000: 'Under 2000',
  scale2000To4000: '2000~4000',
  scale4000To6000: '4000~6000',
  scaleOver6000: 'Over 6000',
  scaleUnknown: 'Unknown',
  // StoreMap
  storeMapLoadingText: 'Loading data, almost there...',
  storeMapCurrentViewport: 'Current viewport: ',
  storeMapClickToSwitchCity: 'Click to switch city',
  storeMapSearchPlaceholder: 'Search location',
  storeMapSchoolDeclare: 'School declaration',
  storeMapStoreSuffix: 'Store',
  storeMapIdLabel: 'ID: ',
  storeMapLinkedSchoolLabel: 'Linked school: ',
  storeMapInvestorContactLabel: 'Investor contact: ',
  storeMapYearSuffix: ' years',
  storeMapNoContent: 'No content',
  storeMapSchoolLocked: 'This public school is locked',
  storeMapCanLockSchool: 'Public school can be locked',
  storeMapPeopleSuffix: ' people',
  storeMapSubmitSuccess: 'Submitted successfully',
  storeMapSubmitFailed: 'Submit failed',
  storeMapOperationFailedRetry: 'Operation failed, please try again later',
  storeMapNationwide: 'Nationwide',
  storeMapNoMatchingResult: 'No matching result',
  storeMapFetchDataFailed: 'Failed to fetch data',
  storeMapStoreCountUnit: ' stores',
  storeMapImageTypeDoor: 'Door sign',
  storeMapImageTypeContract: 'Contract',
  storeMapImageTypeEnvironment: 'Environment',
  storeMapImageTypeFrontDesk: 'Front desk',
  storeMapImageTypeVideo: 'Video',
  storeMapImageTypeStore: 'Store',
  storeMapSubmitDataErrorLog: 'Error submitting school declaration data:',
  storeMapReverseGeocodeFailed: 'Baidu reverse geocoding failed.',
  storeMapBurialPointName: 'Agent Store Map',
  // CustomerApplication
  customerIntentionArea: 'Intended Region',
  customerPhone: 'Customer Phone',
  dianhua: 'Phone',
  audit: 'Audit Opinion',
  customerName: 'Customer Name',
  // Search / config keys used by CustomerApplication
  leadInfo: 'Lead Info',
  customerNameOrPhone: 'Name/Phone',
  textl2db: 'Lead Status',
  pleaseSelectLeadStatus: 'Select Lead Status',
  applicationTime: 'Apply Time',
  submitTime: 'Submit Time',
  to: 'to',
  rewardType: 'Reward Type',
  pleaseSelectRewardMethod: 'Select reward type',
  rewardReferral: 'Referral Reward',
  withdraw: 'Withdraw',
  introducerAgentId: 'Referrer ID',
  introducerAgentName: 'Referrer Name',
  introducerName: 'Referrer',
  introducerAgentRegion: 'Referrer Region',
  introducerAgentArea: 'Referrer Area',
  textctrb: 'Referrer Name',
  textgqvh: 'Referrer Phone',
  texttn6m: 'Comm. Screenshots',
  text2gmn: 'Reward Type',
  withdrawAgentId: 'Withdraw Agent ID',
  textjq5l: 'Withdraw Agent Name',
  payoutsAgentName: 'Withdraw Agent Name',
  auditTime: 'Audit Time',
  text7sbf: 'Audit Info',
  textzbos: 'Referrer Info',
  textluet: 'Reward Info',
  textxrvp: 'Submitter Info',
  texttx22: 'Customer Info',
  textdr39: 'Follow-up Info',
  textoryd: 'Audit Detail',
  // Submitter fields
  submitterName: 'Submitter',
  submitterCampusName: 'Submitter Campus Name',
  submitterAddress: 'Submitter Region',
  customData: 'Customer Background',
  expandUserName: 'Follow-up Person',
  expandUserPic: 'Follow-up Screenshots',
}
